import React, { useRef } from 'react';
import { FileTextIcon } from '@fronton/icons-react';
import { LinkButton, Typography } from 'fronton-react';
import { useTranslation } from 'react-i18next';
import { useBreakpoints } from 'common/hooks';
import { useIntersectionObserverCallback } from '@navi-toolbox/hooks';
import { analyticsUtils } from 'utils';

import { labelLinkButtonStyle, manualWrap, sizeLinkButtonStyle, textWrap } from './manuals.styles';

import { bytesToMegabytes } from '../utils/bytes-to-megabytes';
import { DATA_QA_MANUAL_FILESIZE, DATA_QA_MANUAL_TEXT_WRAP } from './constants';

type ManualsItemProps = {
  url: string;
  filesize?: number | null;
  idx: number;
  manualsLength: number;
};

export const ManualItem = ({ url, filesize, idx, manualsLength }: ManualsItemProps) => {
  const { t } = useTranslation();

  const { mobile } = useBreakpoints() || {
    mobile: false,
  };

  const ref = useRef<HTMLAnchorElement | null>(null);

  const analyticsData = {
    elementType: 'block',
    elementBlock: 'productDetail',
    elementName: 'manuals',
    elementText: 'Инструкция',
  };

  useIntersectionObserverCallback(
    ref,
    {
      enter: () => {
        analyticsUtils.sendEvent('GA:show', analyticsData);
      },
    },
    [],
  );

  const sendAnalytics = () => {
    analyticsUtils.sendEvent('GA:clickButton', analyticsData);
  };

  const filesizeMb = filesize ? `${bytesToMegabytes(filesize)} MB` : null;

  return (
    <LinkButton
      className={manualWrap}
      key={url}
      href={url ?? ''}
      target="_blank"
      ref={ref}
      rel="noopener noreferrer"
      onClick={sendAnalytics}
    >
      <FileTextIcon type="fill" size="space-500" color="text-minor" />

      <div className={textWrap} data-qa={DATA_QA_MANUAL_TEXT_WRAP}>
        <Typography className={labelLinkButtonStyle} size="body_accent" variant="s" color="text-primary">
          {manualsLength > 1
            ? `${t('product-info.manuals.manual')} ${idx + 1}`
            : t('product-info.manuals.manual')}
        </Typography>

        {filesizeMb && !mobile && (
          <Typography
            className={sizeLinkButtonStyle}
            variant="caption"
            color="text-secondary"
            data-qa={DATA_QA_MANUAL_FILESIZE}
          >
            {filesizeMb}
          </Typography>
        )}
      </div>
    </LinkButton>
  );
};
